import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function CheckboxCheckIcon({
  className,
  height,
  stroke = IconColors.White,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height ?? 10}
      viewBoxDimensions="0 0 10 10"
      width={width ?? 10}
    >
      <path
        d="M8.33333 3.33333L3.75 7.91667L1.66667 5.83333"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SimpleIcon>
  );
}
